// eslint-disable-next-line lodash/import-scope
import get from "lodash.get";
import styled, { css } from "../styled";
import { Typography } from "./typography";
export const variantSelector = ({ variant, theme }) => {
    const { font } = theme._ui;
    const styles = {
        displayLarge: css `
      font-size: ${font.size.display.large};
      font-weight: ${font.weight.display};
      line-height: ${font.lineHeight.display.large};
      letter-spacing: -2px;
    `,
        displayMedium: css `
      font-size: ${font.size.display.medium};
      font-weight: ${font.weight.display};
      line-height: ${font.lineHeight.display.medium};
      letter-spacing: -1.25px;
    `,
        displaySmall: css `
      font-size: ${font.size.display.small};
      font-weight: ${font.weight.display};
      line-height: ${font.lineHeight.display.small};
      letter-spacing: -1.25px;
    `,
        headlineLarge: css `
      font-size: ${font.size.headline.large};
      font-weight: ${font.weight.headline};
      line-height: ${font.lineHeight.headline.large};
      letter-spacing: -1px;
    `,
        headlineMedium: css `
      font-size: ${font.size.headline.medium};
      font-weight: ${font.weight.headline};
      line-height: ${font.lineHeight.headline.medium};
      letter-spacing: -0.75px;
    `,
        headlineSmall: css `
      font-size: ${font.size.headline.small};
      font-weight: ${font.weight.headline};
      line-height: ${font.lineHeight.headline.small};
      letter-spacing: -0.5px;
    `,
        titleLarge: css `
      font-size: ${font.size.title.large};
      font-weight: ${font.weight.title};
      line-height: ${font.lineHeight.title.large};
      letter-spacing: -0.25px;
    `,
        titleMedium: css `
      font-size: ${font.size.title.medium};
      font-weight: ${font.weight.title};
      line-height: ${font.lineHeight.title.medium};
      letter-spacing: -0.1px;
    `,
        titleSmall: css `
      font-size: ${font.size.title.small};
      font-weight: ${font.weight.title};
      line-height: ${font.lineHeight.title.small};
    `,
        labelLarge: css `
      font-size: ${font.size.label.large};
      font-weight: ${font.weight.label};
      line-height: ${font.lineHeight.label.large};
    `,
        labelMedium: css `
      font-size: ${font.size.label.medium};
      font-weight: ${font.weight.label};
      line-height: ${font.lineHeight.label.medium};
    `,
        labelSmall: css `
      font-size: ${font.size.label.small};
      font-weight: ${font.weight.label};
      line-height: ${font.lineHeight.label.small};
    `,
        bodyMedium: css `
      font-size: ${font.size.body.medium};
      font-weight: ${font.weight.body};
      line-height: ${font.lineHeight.body.medium};
    `,
        bodyMediumStrong: css `
      font-size: ${font.size.body.medium};
      font-weight: ${font.weight.bodyStrong};
      line-height: ${font.lineHeight.body.medium};
    `,
        bodySmall: css `
      font-size: ${font.size.body.small};
      font-weight: ${font.weight.body};
      line-height: ${font.lineHeight.body.small};
    `,
        bodySmallStrong: css `
      font-size: ${font.size.body.small};
      font-weight: ${font.weight.bodyStrong};
      line-height: ${font.lineHeight.body.small};
    `,
        bodyExtraSmall: css `
      font-size: ${font.size.body.xSmall};
      font-weight: ${font.weight.body};
      line-height: ${font.lineHeight.body.xSmall};
    `,
        bodyExtraSmallStrong: css `
      font-size: ${font.size.body.xSmall};
      font-weight: ${font.weight.bodyStrong};
      line-height: ${font.lineHeight.body.xSmall};
    `,
        captionMedium: css `
      font-size: ${font.size.caption.medium};
      font-weight: ${font.weight.caption};
      line-height: ${font.lineHeight.caption.medium};
    `,
        captionSmall: css `
      font-size: ${font.size.caption.small};
      font-weight: ${font.weight.caption};
      line-height: ${font.lineHeight.caption.small};
    `,
        overlineMedium: css `
      font-size: ${font.size.overline.medium};
      font-weight: ${font.weight.overline};
      line-height: ${font.lineHeight.overline.medium};
      text-transform: uppercase;
      letter-spacing: 1px;
    `,
        overlineSmall: css `
      font-size: ${font.size.overline.small};
      font-weight: ${font.weight.overline};
      line-height: ${font.lineHeight.overline.small};
      text-transform: uppercase;
      letter-spacing: 1px;
    `,
        inherit: css `
      font-size: inherit;
      font-weight: inherit;
      line-height: inherit;
    `,
    };
    return styles[variant];
};
const colorSelector = ({ color, theme }) => {
    const { colors } = theme._ui;
    let selectedColor;
    if (color &&
        (color.includes(".text.") ||
            ["black.default", "white.default"].includes(color)) // Black and white are one-off tokens that do not include 'color' in the path
    ) {
        selectedColor = get(colors, color);
    }
    if (color === "currentColor") {
        selectedColor = "currentColor";
    }
    if (color === "inherit") {
        selectedColor = "inherit";
    }
    if (!selectedColor) {
        selectedColor = get(colors, "surface.text.default");
    }
    return `color: ${selectedColor};`;
};
const clampSelector = ({ clamp }) => {
    if (!clamp || !Number.isInteger(clamp) || clamp < 1) {
        return;
    }
    return css `
    display: -webkit-box;
    word-wrap: break-word;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -webkit-line-clamp: ${clamp};
    line-clamp: ${clamp};
  `;
};
const textAlignSelector = ({ textAlign }) => {
    if (!textAlign) {
        return;
    }
    return `text-align: ${textAlign};`;
};
const EXLUDED_PROPS = ["clamp", "color", "variant", "textAlign"];
const INCLUDED_PROPS = ["component"];
export const StyledTypography = styled(Typography).withConfig({
    shouldForwardProp: (prop, defaultValidator) => {
        return (INCLUDED_PROPS.includes(prop) ||
            (!EXLUDED_PROPS.includes(prop) && defaultValidator(prop)));
    },
}) `
  ${variantSelector}
  ${colorSelector}
  ${clampSelector}
  ${textAlignSelector}
`;
// Required for StoryBook documentation, do not import
export const _ = StyledTypography;
_.displayName = "Text";
/** @deprecated Use Typography instead. This alias will be removed. */
export const Text = StyledTypography;
